import { render } from "./ImagePopUp.vue?vue&type=template&id=7c18b8ac"
import script from "./ImagePopUp.vue?vue&type=script&lang=js"
export * from "./ImagePopUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__